import { useQuery } from "@grandvisionhq/graphql";
import GET_SOCIAL_IDENTITY from "../../../operations/queries/Settings/operations/queries/get-social-identity.js";
const useSocialIdentity = () => {
  const { data, loading, error } = useQuery(GET_SOCIAL_IDENTITY);
  return {
    data: data?.me?.accountMetaData.isSocialIdentity,
    loading,
    error
  };
};
export {
  useSocialIdentity
};
//# sourceMappingURL=use-social-identity.js.map
